import type { RouteRecordRaw } from 'vue-router';

// Lane B (GT1-82) account routes. Profile is the default. Payment-method
// management is a sub-route. Sign-out is an action rendered via PrimeVue
// ConfirmDialog from any of the account pages — not a route — so back-nav
// from a sign-out modal returns to wherever the bidder triggered it.
export const routes: RouteRecordRaw[] = [
  {
    path: '/:slug/account',
    name: 'account',
    component: () => import('./pages/AccountPage.vue'),
    // Anon bidders see an in-page register nudge (same illustration +
    // magic-link pattern as the bid gate), so the route itself doesn't
    // require auth — only payment-methods does.
  },
  {
    path: '/:slug/account/payment-methods',
    name: 'account-payment-methods',
    component: () => import('./pages/PaymentMethodsPage.vue'),
    meta: { requiresAuth: true },
  },
];
